import { ApiModel } from '@composable-api/api.model'

interface Attributes {
    [ThirdPartiesPostcodeEuAutocompleteModel.ATTR_CONTEXT]: string
    [ThirdPartiesPostcodeEuAutocompleteModel.ATTR_PRECISION]: 'Address' | 'Street' | (string & {})
    [ThirdPartiesPostcodeEuAutocompleteModel.ATTR_VALUE]: string
}

export class ThirdPartiesPostcodeEuAutocompleteModel extends ApiModel<Attributes> {
    static key = 'ThirdPartiesPostcodeEuAutocompleteModel'

    static readonly ATTR_CONTEXT = 'context'
    static readonly ATTR_PRECISION = 'precision'
    static readonly ATTR_VALUE = 'value'

    get context() {
        return this._getAttribute(ThirdPartiesPostcodeEuAutocompleteModel.ATTR_CONTEXT)
    }
    get precision() {
        return this._getAttribute(ThirdPartiesPostcodeEuAutocompleteModel.ATTR_PRECISION)
    }
    get value() {
        return this._getAttribute(ThirdPartiesPostcodeEuAutocompleteModel.ATTR_VALUE)
    }
}
